var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitEmitter.apply(null, arguments)}}},[_c('div',{staticClass:"emd-panel"},[_c('emd-address-brazilian-form',{ref:"formComponent",attrs:{"searchZipCodeIsAllowed":_vm.searchZipCode},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }